import { rei } from "@/services/api"

class ProtocolosService {
  static getPdf (data) {
    const options = {
      responseType: 'arraybuffer'
    }

    return rei.post(`relatorio-protocolo`, data, options).then(res => {
      let blob = new Blob([res.data], { type: 'application/pdf' })
      let url = window.URL.createObjectURL(blob)

      return url
    })
  }
}

export default ProtocolosService
